<div>
  <div *ngIf="!notConnected || website?.domain_hash">
    <db-cdn-notice  [websiteId]="website?.id"></db-cdn-notice>
    <db-booster-notices [websiteId]="website?.id" [cachingStatus]="cacheEnabled" [disableOptions]="!!boosterUpdateAvailable" (onClickAction)="loadingPage = true"></db-booster-notices>
    <div class="db-settings" [formGroup]="settingsForm">
      <db-booster-activation-banner *ngIf="!boosterPluginIsActive && !boosterPluginIsOld" [companyName]="companyName" [website]="website" [currentSubscription]="currentSubscription"></db-booster-activation-banner>
      <div class="db-settings__default-mode" [ngClass]="{'reverse': testModeEnabled}">
        <div>
          <db-loading-screen *ngIf="loadingTestMode" [pageBlocker]="true"></db-loading-screen>
        </div>

        <div class="db-settings__cache">
          <div class="db-settings__test" [ngClass]="{'standard': !testModeEnabled}">
            <div>
              <h2>
                <div>
                  <span [innerHTML]="'text_websiteTestMode' | dbText"></span>
                  <i class="db-icon db-icon-info-lined" *ngIf="!testModeEnabled" (click)="toggleKnowLedgeBase()"></i>
                </div>
              </h2>
              <p [innerHTML]="('text_testModeDesc' | dbText: {companyName: companyName}) + '<br><br>' + ('text_testModePreview' | dbText: {companyName: companyName})"></p>
            </div>
            <div class="db-switch-wrap"  [ngClass]="{'disabled-with-overlay': !boosterPluginIsActive && !boosterPluginIsOld}">
              <input id="test-mode-switcher" class="ds-switcher-green ds-control-small green" type="checkbox"
                     (change)="websiteTestMode()" formControlName="testMode" value="{{testModeEnabled}}">
              <label for="test-mode-switcher">
                <span class="ds-switcher-control"></span>
              </label>
            </div>
          </div>
        </div>

      </div>

      <div class="db-settings__cache db-website-caching">

        <div class="db-settings__cache-toggle" *ngIf="!website?.domain_hash">
          <div>
            <h2>
              <span [innerHTML]="'text_websiteCaching' | dbText"></span>
            </h2>
            <p [innerHTML]="'text_websiteCachingDesc' | dbText"></p>
          </div>
          <div class="db-switch-wrap" [ngClass]="{'disabled-with-overlay': !boosterPluginIsActive && !boosterPluginIsOld}" *ngIf="!testModeEnabled">
            <input id="cache-enable-switcher" class="ds-switcher-green ds-control-small" type="checkbox"
                   (change)="websiteCaching()" formControlName="websiteCachingStatus" value="{{cachingStatus}}">
            <label for="cache-enable-switcher">
              <span class="ds-switcher-control"></span>
            </label>
          </div>
          <div class="db-unavailable-text" *ngIf="testModeEnabled">Unavailable in test mode</div>
        </div>

        <div>
          <div>
            <h2>
              <span [innerHTML]="'text_entirelyClearCache' | dbText"></span>
            </h2>
            <p [innerHTML]="'text_entirelyClearCacheDesc' | dbText"></p>
            <b *ngIf="lastClearedCacheDate" [innerHTML]="('text_lastClear' | dbText) + ': ' + (lastClearedCacheDate * 1000 | date: 'MMM d, y, h:mm a')"></b>
          </div>
          <a class="ds-btn-outline-green" [ngClass]="{'disabled-with-overlay': !boosterPluginIsActive && !boosterPluginIsOld, 'ds-btn-disabled': (!cachingStatus || loadingClearCache || testModeEnabled) && !website?.domain_hash}"
             (click)="((!!cachingStatus && !website?.domain_hash) || !!website?.domain_hash) && clearCache()">
            <span *ngIf="!loadingClearCache">{{'text_clearCache' | dbText | lowerCaseSpecificWords}}</span>
            <span class="ds-spinner-circle"  *ngIf="loadingClearCache"></span>
          </a>
        </div>
        <db-loading-screen *ngIf="loadingPageClearCache" [pageBlocker]="true"></db-loading-screen>

      </div>
      <!--<div class="db-settings__cache">
        <div>
          <h2>
            <span [innerHTML]="'text_speedRestore' | dbText"></span>
          </h2>
          <p [innerHTML]="'text_speedRestoreDesc' | dbText"></p>
        </div>
        <a class="ds-btn-outline-green" (click)="restore()">
          <span [innerHTML]="'text_restore' | dbText"></span>
        </a>
      </div>-->

      <db-booster-advanced-settings
        [disableOptions]="!!boosterUpdateAvailable"
        [testModeEnabled]="testModeEnabled"
        [demoUser]="demoUser"
        [websiteId]="website?.id">
      </db-booster-advanced-settings>
    </div>
    <db-loading-screen *ngIf="loadingPage"></db-loading-screen>
  </div>
  <div class="db-trouble-instructions" *ngIf="notConnected && !website?.domain_hash">
    <div>
      <db-booster-trouble-instructions [insideWebsite]="true" [website]="website" [currentSubscription]="currentSubscription"></db-booster-trouble-instructions>
    </div>
  </div>
</div>
